import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Register from '_components/Register';
// import '_assets/landingPage/css/bootstrap.css'
// import '_assets/landingPage/css/main.css'
import Navigation from './Navigation'
import { Footer } from './Footer'
import LeftCircle from '_assets/landingPage/images/left-circle.svg'
import Star from '_assets/landingPage/images/star.svg'
import Stock3 from '_assets/landingPage/images/iStock3.jpg'
import Stock4 from '_assets/landingPage/images/iStock4.jpg'
import Stock2 from '_assets/landingPage/images/iStock4.jpg'
import Img from '_assets/landingPage/images/img.jpg'
import Shape4 from '_assets/landingPage/images/shape-4.svg'
import Logo from '_assets/landingPage/images/logo.png'

import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import Login from '_components/Login';

export function FI() {
  const dispatch = useDispatch();
  const [showRegister, setShowRegister] = useState(false)
  const [showLogin, setShowLogin] = useState(false)



  return (
  <></>
                  );

}


